import React from 'react';

const Phone = () => {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M11.5595 15.6012C12.5968 17.7218 14.3158 19.433 16.4412 20.4607C16.5967 20.5344 16.7687 20.5663 16.9403 20.5533C17.1119 20.5403 17.2771 20.4829 17.4198 20.3866L20.5492 18.2998C20.6877 18.2075 20.8469 18.1512 21.0126 18.136C21.1782 18.1208 21.3451 18.1472 21.498 18.2127L27.3526 20.7218C27.5515 20.8063 27.7175 20.9531 27.8257 21.1402C27.9339 21.3272 27.9783 21.5444 27.9524 21.7589C27.7673 23.2069 27.0608 24.5378 25.9652 25.5024C24.8695 26.467 23.4598 26.9992 22 26.9993C17.4913 26.9993 13.1673 25.2082 9.97919 22.0201C6.79107 18.832 5 14.5079 5 9.99927C5.00008 8.53949 5.53224 7.12978 6.49685 6.03411C7.46146 4.93844 8.79237 4.23194 10.2404 4.04689C10.4549 4.02093 10.672 4.06539 10.8591 4.17357C11.0461 4.28175 11.193 4.44779 11.2775 4.64667L13.7888 10.5064C13.8537 10.658 13.8802 10.8233 13.8658 10.9875C13.8514 11.1518 13.7967 11.31 13.7064 11.4479L11.6268 14.6254C11.5322 14.7683 11.4762 14.9334 11.4644 15.1044C11.4526 15.2754 11.4854 15.4466 11.5595 15.6012V15.6012Z'
				stroke='white'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Phone;
